<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<div class="table-topbar mb-20">
  <div class="search-panel">
    <div class="search-control">
      <span class="icon-search"></span>
      <input type="search" class="form-control table-search" [formControl]="searchControl" />
    </div>
  </div>
  <div class="table-action-holder">
  </div>
</div>
<ag-grid-angular [gridOptions]="gridOptions" [rowData]="points" [ngClass]="[theme]" style="width: 100%;height: 700px"></ag-grid-angular>
